import React, { useState } from "react";

// Reuse the branded menu images already generated for gallery
import gal1 from "../assets/menu/classic_biryani_combo.png";
import gal2 from "../assets/menu/mutton_biryani.png";
import gal3 from "../assets/menu/seafood_combo.png";
import gal4 from "../assets/menu/chicken_fried_rice_box.png";
import gal5 from "../assets/menu/prawn_biryani.png";
import gal6 from "../assets/menu/double_combo_box.png";

const galleryImages = [
  {
    src: gal1,
    alt: "Classic Seeraga Samba Biryani Combo",
    label: "Combo Meals",
  },
  { src: gal2, alt: "Special Mutton Biryani", label: "Biryani" },
  { src: gal3, alt: "Seafood Combo Box", label: "Seafood" },
  { src: gal4, alt: "Chicken Fried Rice Box", label: "Rice Box" },
  { src: gal5, alt: "Seeraga Samba Prawn Biryani", label: "Biryani" },
  { src: gal6, alt: "Double Combo Box", label: "Value Deals" },
];

const GallerySection = () => {
  const [lightbox, setLightbox] = useState(null);

  return (
    <section className="py-20 bg-[#0d0d0d]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Title */}
        <div className="text-center mb-14">
          <p className="text-[11px] font-semibold uppercase tracking-[4px] text-[#cd3a27] mb-3">
            Food Gallery
          </p>
          <h2 className="text-5xl md:text-6xl font-['Dancing_Script'] text-white font-medium leading-none">
            Our Delicious Combos
          </h2>
          {/* Ornamental Divider */}
          <div className="flex items-center justify-center gap-3 mt-5">
            <div className="h-[1px] w-20 bg-gradient-to-r from-transparent to-[#cd3a27]"></div>
            <div className="w-2 h-2 border border-[#cd3a27] rotate-45"></div>
            <div className="h-[1px] w-20 bg-gradient-to-l from-transparent to-[#cd3a27]"></div>
          </div>
          <p className="mt-5 text-sm text-gray-400 max-w-md mx-auto leading-relaxed">
            100% Halal · Fresh Daily · Packed with Flavour
          </p>
        </div>

        {/* Masonry-style Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {galleryImages.map((img, i) => (
            <div
              key={i}
              onClick={() => setLightbox(img)}
              className={`group relative overflow-hidden rounded-xl cursor-pointer shadow-lg ${
                i === 1 ? "md:row-span-2" : ""
              }`}
              style={{ height: i === 1 ? undefined : "240px" }}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                style={{
                  height: i === 1 ? "100%" : "240px",
                  minHeight: i === 1 ? "496px" : "240px",
                }}
              />
              {/* Gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400 flex flex-col justify-end p-4">
                <span className="text-[10px] font-bold uppercase tracking-widest text-[#cd3a27] mb-1">
                  {img.label}
                </span>
                <p className="text-white text-sm font-semibold leading-tight">
                  {img.alt}
                </p>
              </div>

              {/* Zoom icon */}
              <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="bg-white/90 rounded-full p-1.5 shadow-md">
                  <svg
                    className="w-4 h-4 text-gray-800"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                    />
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {lightbox && (
        <div
          className="fixed inset-0 z-[200] flex items-center justify-center bg-black/92 p-4"
          onClick={() => setLightbox(null)}
        >
          <div
            className="relative max-w-3xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute -top-5 -right-5 bg-white text-gray-900 rounded-full p-2 shadow-lg hover:bg-gray-100 transition-colors z-10"
              onClick={() => setLightbox(null)}
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2.5"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <img
              src={lightbox.src}
              alt={lightbox.alt}
              className="w-full max-h-[80vh] object-contain rounded-2xl shadow-2xl"
            />
            <div className="mt-3 text-center">
              <span className="text-[10px] font-bold uppercase tracking-widest text-[#cd3a27]">
                {lightbox.label}
              </span>
              <p className="text-white text-base font-semibold mt-1">
                {lightbox.alt}
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default GallerySection;
